import { useEffect, useState } from 'react';
import axios from 'axios';
import { Sparkles, Plus, Check, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { API_CP, dejaPresent } from './constantes';

const SOURCES = {
  r6231_4: ['Art. R.6231-4', 'bg-blue-50 text-blue-700'],
  activite: ["Activité de l'appli", 'bg-emerald-50 text-emerald-700'],
  seance: ['Séance', 'bg-slate-100 text-slate-600'],
};

export const SuggestionsOdj = ({ annee, points, onAjouter }) => {
  const [liste, setListe] = useState(null);
  useEffect(() => {
    axios.get(`${API_CP(annee)}/suggestions`).then(({ data }) => setListe(data)).catch(() => setListe([]));
  }, [annee]);
  const restantes = (liste || []).filter((s) => !dejaPresent(points, s));

  return (
    <aside className="rounded-2xl border border-dashed border-[#8DC63F]/70 bg-[#8DC63F]/5 p-5" data-testid="cp-suggestions">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="flex items-center gap-2 font-semibold text-[#0F172A]"><Sparkles className="h-4 w-4 text-[#6FA22E]" /> Propositions</h3>
          <p className="mt-0.5 text-xs text-slate-500">Les 8 thèmes du Code du travail, complétés avec les chiffres de l'application.</p>
        </div>
        {restantes.length > 0 && (
          <Button size="sm" variant="outline" className="shrink-0 bg-white" onClick={() => restantes.forEach((s) => onAjouter(s.titre, s.details, s.cle))} data-testid="cp-suggestions-tout">Tout ajouter</Button>
        )}
      </div>
      {liste === null && <div className="flex justify-center py-8"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>}
      <ul className="mt-4 space-y-2.5">
        {(liste || []).map((s) => {
          const deja = dejaPresent(points, s);
          const [label, classe] = SOURCES[s.source] || SOURCES.seance;
          return (
            <li key={s.cle} className={`rounded-xl bg-white p-3 shadow-sm transition-opacity ${deja ? 'opacity-50' : ''}`} data-testid={`cp-suggestion-${s.cle}`}>
              <div className="flex items-start gap-2">
                <div className="min-w-0 flex-1">
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${classe}`}>{label}</span>
                  <p className="mt-1.5 text-sm font-medium text-[#0F172A]">{s.titre}</p>
                  {s.details && <p className="mt-1 line-clamp-3 text-xs text-slate-500">{s.details}</p>}
                </div>
                <Button size="icon" variant={deja ? 'ghost' : 'secondary'} disabled={deja} onClick={() => onAjouter(s.titre, s.details, s.cle)}
                  className="h-8 w-8 shrink-0" data-testid={`cp-suggestion-ajouter-${s.cle}`}>
                  {deja ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                </Button>
              </div>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};
